import { makeStyles } from "@mui/styles";
export var useImageStyles = makeStyles(function () { return ({
    blur: {
        filter: "blur(3px)",
    },
}); });
